import { useImperativeHandle as u } from "react";
const t = (e, r) => {
  u(
    e,
    () => ({
      focus() {
        r.current.focus();
      },
      blur() {
        r.current.blur();
      }
    }),
    [r]
  );
};
export {
  t as s
};
//# sourceMappingURL=useForwardFocusOnInput-p4vGEjFi.js.map
